var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'pship-columns-slider': true,
    'pship-columns-slider__gradient': _vm.gradient
  }},_vm._l((_vm.groups),function(ref){
  var group = ref.group;
return _c('div',{key:group,class:{
      'pship-columns-slider__slider-group': true,
      'pship-columns-slider__slider-group--selected': group === _vm.active
    },on:{"click":function($event){$event.preventDefault();return _vm.handlerGroupChange(group)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }